import { useState, useCallback } from "react"

import useTracking from "hooks/useTracking"
import { useComponentizedPage } from "store/contexts/componentized-page"
import { navigate } from "gatsby"

const useClassFreePreview = () => {
  const [posting, setPosting] = useState(false)
  const [error, setError] = useState(null)

  const { classesOnPage } = useComponentizedPage()
  const { track } = useTracking()

  const createFreeTrial = useCallback(
    async (classId, email) => {
      setPosting(true)
      setError(null)

      try {
        const response = await fetch("/classes/preview", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: classId, email }),
        })
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        const data = await response.json()

        track("Preview Activated", {
          class_id: classId,
          category: "Class Engagement",
          label: "class_id",
        })

        if (data.redirect) {
          navigate(data.redirect)
        }
      } catch (err) {
        setError(err.data.message)
        console.error(err)
      }

      setPosting(false)
    },
    [classesOnPage],
  )

  return [posting, error, createFreeTrial]
}

export default useClassFreePreview
